import { render } from "./App.vue?vue&type=template&id=4f4e62a0&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=4f4e62a0&lang=scss"

import exportComponent from "/builds/gh_devops/h5news_prod_deploy/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__